export const colors = {
  primary: "#ed6c10",
  secondary: "#777777",
  success: "#E6F2E8",
  dark: "#1D1D1D",
  darkPage: "#121212",
  positive: "#5CB15C",
  negative: "#7F3225",
  info: "#CC5435",
  danger: "#FBEDEA",
  warning: "#FEF6E9",
  main: "#F8F8F8",
};


export const KEY_TOKEN = "front-token"
export const KEY_USERINFO = "user_info"
